<template>
	<div class="sing-up">
		<div class="fields__item">
			<button @click="$root.OAuth('vkontakte')" class="btn btn--block">
				<svg class="btn__icon"><use href="#svg-icon-vk"></use></svg>
				<span>Регистрация через Вконтакте</span>
			</button>
		</div>
		<div class="fields__item">
			<button @click="$root.OAuth('telegram')" class="btn btn--block">
				<svg class="btn__icon"><use href="#svg-icon-tg"></use></svg>
				<span>Регистрация через Telegram</span>
			</button>
		</div>
		<div class="fields__item">
			<button @click="$root.OAuth('google')" class="btn btn--block">
				<svg class="btn__icon"><use href="#svg-icon-google"></use></svg>
				<span>Регистрация через Google</span>
			</button>
		</div>
		<div class="fields__item">
			<button @click="$root.OAuth('mailru')" class="btn btn--block">
				<svg class="btn__icon"><use href="#svg-icon-mailru"></use></svg>
				<span>Регистрация через mail.ru</span>
			</button>
		</div>
		<div class="fields__item">
			<button @click="$root.OAuth('yandex')" class="btn btn--block">
				<svg class="btn__icon"><use href="#svg-icon-yandex"></use></svg>
				<span>Регистрация через Yandex</span>
			</button>
		</div>
		<div class="fields__item">
			<div class="sing-in__note">Создавая аккаунт и пользуясь услугами сайта, вы соглашаетесь с
				<a href="terms" target="_blank"> Правилами сайта</a>
				 Регистрировать более 1-го аккаунта запрещено. Все мультиаккаунты блокируем.
			</div>
		</div>
		<div class="fields__item" v-if="errors.show">
			{{ errors.message }}
		</div>
		<div class="fields__item">
			<div class="sing-in__note">Есть аккаунт?
				<button class="sing-in__note-link" type="button" @click="handlerSingIn">Войти</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		emits: [
				'openSingIn'
		],

		data() {
			return {
				username: '',
				password: '',
				password_confirm: '',
				errors: {
				    show: false,
				    message: ''
				},
				disableBtn: false
			}
		},

		methods: {
			handlerSingIn() {
				this.$emit('openSingIn');
			}
		}
	}
</script>